module.exports = __webpack_public_path__ + "img/ug531.cd2709ea.png";